import { Button, ModalWindow, UIHeading2, UIHeading3, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import styles from './AreaPartModal.css';
import { IAreaPartModalProps } from './types';
import cn from 'classnames';

export const AreaPartModal: React.FC<IAreaPartModalProps> = props => {
  const { opened, onApproveButtonClick, onClose, heading, description, approveButtonTitle } = props;

  const isMobile = useDeviceType() === 'phone';

  const Heading = isMobile ? UIHeading2 : UIHeading3;
  const Description = isMobile ? UIText1 : UIText2;

  const content = (
    <div className={cn(isMobile && styles['mobile-container'])}>
      <Heading>{heading}</Heading>
      <div className={cn(styles['description-container'], isMobile && styles['mobile-description-container'])}>
        <Description>{description}</Description>
      </div>
      <div className={cn(styles['buttons-container'], isMobile && styles['mobile-buttons-container'])}>
        <Button size={isMobile ? 'M' : 'XS'} onClick={onApproveButtonClick}>
          {approveButtonTitle}
        </Button>
        <div className={cn(styles['cancel-button-container'], isMobile && styles['mobile-cancel-button-container'])}>
          <Button size={isMobile ? 'M' : 'XS'} theme="fill_white_primary" onClick={onClose}>
            Отменить
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <ModalWindow escape content={content} fixed={false} width={448} onClose={onClose} open={opened} outside size="XS" />
  );
};
